import { css } from 'linaria';

export const container = css`
  display: flex;
  flex-wrap: wrap;
  margin-top: var(--space-1000);
  padding-bottom: var(--space-1000);
  position: relative;

  @media (--only-mobile) {
    padding-bottom: var(--space-500);
  }
`;

export const linkedPagesWrapper = css`
  width: 100%;
  display: flex;
  gap: var(--space-100);
  flex-wrap: wrap;
  box-sizing: border-box;
  padding-bottom: var(--space-200);
  margin-top: var(--space-150);
  overflow: hidden;
`;

export const fadeButton = css`
  position: relative;
  box-shadow: none;
  left: 0;
`;

export const linkedPageItem = css`
  display: inline-block;
  opacity: 1;
  height: fit-content;
  transition: none;

  @media (--to-desktop) {
    max-width: 330px;
  }

  & > *:first-child {
    overflow: hidden;

    @media (--to-desktop) {
      text-overflow: ellipsis;
    }
  }

  &[data-hidden='true'] {
    max-width: 0;
    max-height: 0;
    padding: 0;
    overflow: hidden;
    border: none;
    opacity: 0;
  }
`;
